module.exports = __webpack_public_path__ + "static/location-pin-1b143a640e4c934d70bc5fab0b2c5009.png";